export default __webpack_public_path__ + "static/media/icone_intertidal_png.657e5779.png";